import type { CSSProperties } from 'react'

const fonts = {
  mono: '--font-mono',
  sauce: '--font-sauce',
  sans: '--font-sans',
  therma: '--font-therma',
} as const

const typography: TypeStyles = {
  h1: {
    'font-family': `var(${fonts.therma})`,
    'font-style': 'normal',
    'letter-spacing': { mobile: '-0.03em', desktop: '-0.05em' },
    'font-weight': 700,
    'line-height': '80%',
    'font-feature-settings': '"ss04"',
    'font-size': { mobile: 72, desktop: 120 },
  },

  h2: {
    'font-family': `var(${fonts.therma})`,
    'font-style': 'normal',
    'font-weight': 700,
    'line-height': '80%',
    'letter-spacing': '-0.03em',
    'font-feature-settings': '"ss04"',
    'font-size': { mobile: 32, desktop: 48 },
  },
  cta: {
    'font-family': `var(${fonts.mono})`,
    'font-style': 'normal',
    'font-weight': 200,
    'line-height': '100%',
    'letter-spacing': '-0.01em',
    'font-feature-settings': '"case"',
    'font-size': { mobile: 12, desktop: 14 },
  },
  p: {
    'font-family': `var(${fonts.mono})`,
    'font-style': 'normal',
    'font-weight': 200,
    'line-height': { mobile: '125%', desktop: '120%' },
    'letter-spacing': '-0.01em',
    'font-size': { mobile: 12, desktop: 14 },
  },
  'p-s': {
    'font-family': `var(${fonts.mono})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': { mobile: '125%', desktop: '120%' },
    'letter-spacing': '-0.01em',
    'font-size': { mobile: 12, desktop: 14 },
  },
  'p-l': {
    'font-family': `var(${fonts.mono})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '125%',
    'letter-spacing': '-0.02em',
    'font-size': { mobile: 16, desktop: 20 },
  },
  link: {
    'font-family': `var(${fonts.mono})`,
    'font-style': 'normal',
    'font-weight': 200,
    'line-height': { mobile: '125%', desktop: '120%' },
    'letter-spacing': '-0.01em',
    'font-feature-settings': '"case"',
    'font-size': { mobile: 12, desktop: 14 },
  },

  caption: {
    'font-family': `var(${fonts.mono})`,
    'font-style': 'normal',
    'font-weight': 200,
    'line-height': { mobile: '125%', desktop: '120%' },
    'letter-spacing': '-0.01em',
    'font-feature-settings': '"case"',
    'font-size': { mobile: 8, desktop: 10 },
  },
  hero: {
    'font-family': `var(${fonts.sauce})`,
    'font-style': 'normal',
    'letter-spacing': '0em',
    'font-weight': 400,
    'line-height': '100%',
    'font-size': { mobile: 80, desktop: 270 },
  },
  'hero-alt': {
    'font-family': `var(${fonts.therma})`,
    'font-style': 'normal',
    'letter-spacing': '0em',
    'font-weight': 700,
    'line-height': '80%',
    'font-size': { mobile: 80, desktop: 86 },
  },
  banner: {
    'font-family': `var(${fonts.sauce})`,
    'font-style': 'normal',
    'letter-spacing': '0em',
    'font-weight': 400,
    'line-height': '100%',
    'font-size': { mobile: 40, desktop: 86 },
  },
} as const

export { fonts, typography }

// UTIL TYPES
type TypeStyles = Record<
  string,
  {
    'font-family': string
    'font-style': CSSProperties['fontStyle']
    'font-weight': CSSProperties['fontWeight']
    'line-height':
      | `${number}%`
      | { mobile: `${number}%`; desktop: `${number}%` }
    'letter-spacing':
      | `${number}em`
      | { mobile: `${number}em`; desktop: `${number}em` }
    'font-feature-settings'?: string
    'font-size': number | { mobile: number; desktop: number }
  }
>
